import React from 'react';
import { useTranslation } from 'react-i18next';
import { ImageIcon } from 'lucide-react';
import { FileUpload } from '@/components/file-upload';
import { useDropzone } from 'react-dropzone';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';
export const FileDropZone = ({ images, onDrop, onUpload, onRemove }) => {
    const { t } = useTranslation();
    const { getRootProps, getInputProps, isDragActive } = useDropzone({
        onDrop,
        // Broad accept matches the FileUpload <input accept="image/*"> below —
        // dropping a HEIC/WebP photo previously did not fire onDrop, leaving
        // the upload button stuck disabled because file state never updated.
        accept: { 'image/*': [] },
    });
    return (<React.Fragment>
            <div className={cn('flex flex-col items-center gap-2 rounded-lg border-2 border-dashed p-8 transition-colors', isDragActive
            ? 'border-primary/60 bg-primary/5 text-foreground'
            : 'border-border bg-muted/20 text-muted-foreground hover:border-muted-foreground/50 hover:bg-muted/30')} {...getRootProps()}>
                <input {...getInputProps()}/>
                <ImageIcon className="h-10 w-10 opacity-70"/>
                {isDragActive ? (<React.Fragment>
                        <span className="text-sm font-medium">{t('image.drop_here', { ns: 'glossary' })}</span>
                        <span className="text-xs opacity-80">({t('image.only', { ns: 'glossary' })})</span>
                    </React.Fragment>) : (<React.Fragment>
                        <span className="text-sm font-medium">{t('image.drop_click', { ns: 'glossary' })}</span>
                        <span className="text-xs opacity-80">({t('image.only', { ns: 'glossary' })})</span>
                    </React.Fragment>)}
            </div>
            <FileUpload onChange={onUpload}/>
            {images.map((imageFile, index) => (<div className="flex flex-row items-center justify-between gap-3 rounded-md border border-border/60 bg-muted/20 p-2" key={`file-drop-zone-image-${index}`}>
                    <img src={URL.createObjectURL(imageFile)} alt="Preview" className="h-12 w-12 rounded object-cover"/>
                    <span className="min-w-0 flex-1 truncate text-sm">{imageFile.name}</span>
                    <Button className="text-destructive" variant="ghost" onClick={() => onRemove(index)}>
                        {t('remove')}
                    </Button>
                </div>))}
        </React.Fragment>);
};
FileDropZone.displayName = 'FileDropZone';
